// AIM FLEX Corporate Website Data with Smart Quote System

export const aimflexData = {
  // Company Information - AIM FLEX Rebrand
  company: {
    name: 'Aim Flex',
    tagline: 'Your Vision, Our Canvas',
    description: 'Premier Advertisement & Branding Company',
    subDescription: 'Large-Format Printing & Signage Solutions',
    established: '1997',
    location: 'Madurai, Tamil Nadu',
    experience: '25+ years',
    mission: 'Revolutionizing customer experience through pricing transparency and premium quality'
  },

  // Contact Information (Same as requested)
  contact: {
    phone: '+91 9943281483',
    email: 'info@aimflex.com',
    whatsapp: '+91 9943281483',
    address: {
      street: '34, EMS Nagar',
      area: 'Ponmeni, Bye Pass Road',
      city: 'Madurai',
      state: 'Tamil Nadu',
      pincode: '625016'
    },
    fullAddress: '34, EMS Nagar, Ponmeni, Bye Pass Road, Madurai. Tamil Nadu 625016, India',
    googleMapsLink: 'https://maps.app.goo.gl/W5WaQEr5juLVAd1px',
    businessHours: 'Mon-Sat 9AM-7PM'
  },

  // Core Product Categories with Pricing
  productCategories: [
    {
      id: 1,
      name: 'Flex Printing',
      description: 'Premium outdoor and indoor flex printing solutions',
      priceRange: '₹10 - ₹70 / sq ft',
      minPrice: 10,
      maxPrice: 70,
      materials: [
        {
          id: 'uv-flex',
          name: 'UV Flex',
          price: 70,
          description: 'Premium outdoor durability',
          bestFor: 'Hoardings & Outdoor Signage',
          features: ['Weather resistant', 'UV protected', '5+ years lifespan']
        },
        {
          id: 'eco-solvent-flex',
          name: 'Eco Solvent Flex',
          price: 45,
          description: 'Environmentally friendly',
          bestFor: 'Indoor/Close proximity displays',
          features: ['Eco-friendly', 'High quality print', '3+ years lifespan']
        },
        {
          id: 'inkjet-flex',
          name: 'Inkjet Print Flex',
          price: 25,
          description: 'High-resolution digital printing',
          bestFor: 'Event backdrops & Banners',
          features: ['High resolution', 'Vibrant colors', '2+ years lifespan']
        }
      ]
    },
    {
      id: 2,
      name: 'Vinyl Printing',
      description: 'Durable vinyl printing for vehicles and signage',
      priceRange: '₹25 - ₹85 / sq ft',
      minPrice: 25,
      maxPrice: 85,
      materials: [
        {
          id: 'uv-vinyl',
          name: 'UV Vinyl',
          price: 85,
          description: 'Fade-resistant outdoor vinyl',
          bestFor: 'Vehicle wraps & Outdoor signs',
          features: ['Fade resistant', 'Weather proof', '7+ years lifespan']
        },
        {
          id: 'eco-solvent-vinyl',
          name: 'Eco Solvent Vinyl',
          price: 55,
          description: 'Versatile indoor/outdoor vinyl',
          bestFor: 'Wall graphics & Window decals',
          features: ['Versatile use', 'Easy application', '5+ years lifespan']
        },
        {
          id: 'inkjet-vinyl',
          name: 'Inkjet Print Vinyl',
          price: 35,
          description: 'Precision detailed printing',
          bestFor: 'Indoor displays & Graphics',
          features: ['High detail', 'Smooth finish', '3+ years lifespan']
        }
      ]
    }
  ],

  // Sub-Products Catalog
  subProducts: [
    {
      id: 1,
      name: 'Foam Board with Vinyl',
      price: 120,
      unit: 'per sq ft',
      description: 'Lightweight display boards with premium vinyl finish',
      category: 'Display Boards',
      features: ['Lightweight', 'Easy to mount', 'Professional finish']
    },
    {
      id: 2,
      name: '3D Acrylic Board',
      price: 250,
      unit: 'per sq ft',
      description: 'Premium 3D acrylic signage for modern businesses',
      category: 'Premium Signage',
      features: ['3D effect', 'Premium look', 'Durable']
    },
    {
      id: 3,
      name: 'ACP Board',
      price: 180,
      unit: 'per sq ft',
      description: 'Aluminum Composite Panel for professional signage',
      category: 'Building Signage',
      features: ['Weather resistant', 'Professional', 'Long lasting']
    },
    {
      id: 4,
      name: 'Roll Up Standee',
      price: 1500,
      unit: 'per piece',
      description: 'Portable roll-up displays for events and promotions',
      category: 'Event Displays',
      features: ['Portable', 'Easy setup', 'Reusable']
    },
    {
      id: 5,
      name: 'Back Light Board',
      price: 300,
      unit: 'per sq ft',
      description: 'Illuminated back-lit signage for night visibility',
      category: 'Illuminated Signs',
      features: ['LED backlight', 'Night visibility', 'Energy efficient']
    },
    {
      id: 6,
      name: 'Front Light Board',
      price: 280,
      unit: 'per sq ft',
      description: 'Front-lit signage for enhanced visibility',
      category: 'Illuminated Signs',
      features: ['Front lighting', 'Bright display', 'Professional look']
    },
    {
      id: 7,
      name: 'Visiting Cards',
      price: 3,
      unit: 'per piece',
      description: 'Professional business cards with premium finish',
      category: 'Business Stationery',
      features: ['Premium paper', 'Multiple finishes', 'Quick delivery']
    },
    {
      id: 8,
      name: 'Pamphlets',
      price: 2,
      unit: 'per piece',
      description: 'High-quality promotional pamphlets',
      category: 'Marketing Materials',
      features: ['High-quality print', 'Various sizes', 'Bulk discounts']
    },
    {
      id: 9,
      name: 'Brochures',
      price: 8,
      unit: 'per piece',
      description: 'Professional tri-fold and bi-fold brochures',
      category: 'Marketing Materials',
      features: ['Premium paper', 'Professional design', 'Multiple folds']
    },
    {
      id: 10,
      name: 'Booklets',
      price: 15,
      unit: 'per piece',
      description: 'Multi-page booklets for catalogs and manuals',
      category: 'Publications',
      features: ['Multiple pages', 'Binding options', 'Custom sizes']
    }
  ],

  // Add-on Services and Pricing
  addOns: [
    {
      id: 'lamination-matte',
      name: 'Matte Lamination',
      price: 15,
      unit: 'per sq ft',
      description: 'Matte finish lamination for reduced glare'
    },
    {
      id: 'lamination-gloss',
      name: 'Gloss Lamination',
      price: 15,
      unit: 'per sq ft',
      description: 'High-gloss lamination for enhanced vibrancy'
    },
    {
      id: 'cutting',
      name: 'Custom Cutting',
      price: 5,
      unit: 'per linear ft',
      description: 'Precision cutting to custom shapes'
    },
    {
      id: 'grommets',
      name: 'Grommets',
      price: 8,
      unit: 'per piece',
      description: 'Metal grommets for hanging and mounting'
    },
    {
      id: 'mounting',
      name: 'Professional Mounting',
      price: 50,
      unit: 'per sq ft',
      description: 'Professional installation and mounting service'
    }
  ],

  // Smart Quote Calculator Logic
  quoteCalculator: {
    calculatePrice: (category, material, width, height, addOns = []) => {
      const area = width * height;
      let basePrice = 0;
      
      // Find material price - fix category matching
      if (category === 'flexprinting' || category === 'flex') {
        const flexCategory = aimflexData.productCategories.find(cat => cat.id === 1);
        const selectedMaterial = flexCategory.materials.find(mat => mat.id === material);
        basePrice = selectedMaterial ? selectedMaterial.price * area : 0;
      } else if (category === 'vinylprinting' || category === 'vinyl') {
        const vinylCategory = aimflexData.productCategories.find(cat => cat.id === 2);
        const selectedMaterial = vinylCategory.materials.find(mat => mat.id === material);
        basePrice = selectedMaterial ? selectedMaterial.price * area : 0;
      }
      
      // Calculate add-on costs
      let addOnCost = 0;
      addOns.forEach(addOnId => {
        const addOnItem = aimflexData.addOns.find(item => item.id === addOnId);
        if (addOnItem) {
          if (addOnItem.unit === 'per sq ft') {
            addOnCost += addOnItem.price * area;
          } else if (addOnItem.unit === 'per piece') {
            addOnCost += addOnItem.price * 1; // Default quantity 1
          } else if (addOnItem.unit === 'per linear ft') {
            addOnCost += addOnItem.price * (width * 2 + height * 2); // Perimeter
          }
        }
      });
      
      return {
        area: area,
        basePrice: basePrice,
        addOnCost: addOnCost,
        totalPrice: basePrice + addOnCost,
        priceBreakdown: {
          material: basePrice,
          addOns: addOnCost
        }
      };
    }
  },

  // Portfolio Projects with Material Details
  portfolio: [
    {
      id: 1,
      title: 'Premium Mall Hoarding',
      category: 'Flex Printing',
      material: 'UV Flex',
      size: '20x10 ft',
      price: '₹14,000',
      image: 'https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=500&h=400&fit=crop',
      description: 'Large-scale mall advertising hoarding with UV flex for maximum durability',
      client: 'Phoenix Mall',
      completionTime: '3 days'
    },
    {
      id: 2,
      title: 'Restaurant Vehicle Wrap',
      category: 'Vinyl Printing',
      material: 'UV Vinyl',
      size: '120 sq ft',
      price: '₹10,200',
      image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=500&h=400&fit=crop',
      description: 'Full vehicle wrap for food delivery service with fade-resistant UV vinyl',
      client: 'Taste Express',
      completionTime: '2 days'
    },
    {
      id: 3,
      title: 'Corporate ACP Signage',
      category: 'Sub Products',
      material: 'ACP Board',
      size: '8x4 ft',
      price: '₹5,760',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=500&h=400&fit=crop',
      description: 'Professional aluminum composite panel signage for corporate office',
      client: 'Tech Solutions Ltd',
      completionTime: '5 days'
    }
  ],

  // Testimonials
  testimonials: [
    {
      id: 1,
      name: 'Rajesh Kumar',
      designation: 'Store Owner',
      company: 'Kumar Electronics',
      rating: 5,
      text: 'The pricing calculator on AIM FLEX website made it so easy to budget my project. The UV Flex hoarding quality exceeded expectations!',
      location: 'Madurai, TN',
      project: 'UV Flex Hoarding'
    },
    {
      id: 2,
      name: 'Priya Sharma',
      designation: 'Marketing Manager',
      company: 'Event Pro',
      rating: 5,
      text: 'Smart quote system saved us hours of back-and-forth. Got accurate pricing instantly for our roll-up standees and vinyl banners.',
      location: 'Chennai, TN',
      project: 'Event Materials'
    },
    {
      id: 3,
      name: 'Mohammed Asif',
      designation: 'Business Owner',
      company: 'Asif Automobiles',
      rating: 5,
      text: 'Transparent pricing and premium quality! The vehicle wrap was completed exactly as quoted. Highly professional service.',
      location: 'Coimbatore, TN',
      project: 'Vehicle Vinyl Wrap'
    }
  ],

  // Brand Colors
  brandColors: {
    primary: '#E53E3E', // Primary Red
    white: '#FFFFFF',   // Clean White  
    black: '#000000',   // Bold Black
    secondary: {
      lightRed: '#FEB2B2',
      darkRed: '#C53030',
      gray: '#718096'
    }
  }
};

// Smart Quote Form Handler
export const generateQuote = async (quoteData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  const { category, material, width, height, addOns, customerInfo } = quoteData;
  
  const calculation = aimflexData.quoteCalculator.calculatePrice(
    category, material, parseFloat(width), parseFloat(height), addOns
  );
  
  // Generate quote reference
  const quoteRef = 'AIM' + Date.now().toString().slice(-6);
  
  console.log('Quote Generated:', {
    reference: quoteRef,
    customer: customerInfo,
    specifications: { category, material, width, height, addOns },
    pricing: calculation
  });
  
  return {
    success: true,
    quoteReference: quoteRef,
    calculation: calculation,
    message: `Quote ${quoteRef} generated successfully! Our team will contact you within 2 hours.`
  };
};

// Contact form submission for AIM FLEX
export const submitAimFlexContact = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 800));
  
  console.log('AIM FLEX Contact submitted:', formData);
  
  return {
    success: true,
    message: 'Thank you for choosing AIM FLEX! We will contact you within 24 hours with detailed information.'
  };
};